import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridsterModule } from 'angular-gridster2';
import { ChartModule } from '@progress/kendo-angular-charts';
import { PopupModule } from '@progress/kendo-angular-popup';

import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { TileColumnSettingComponent } from './tile-column-setting/tile-column-setting.component';
import { TileColumnComponent } from './tile-column-setting/tile-column.component';
import { TileEntryColumnDetailComponent } from './tile-column-setting/tile-entry-column-detail.component';
import { TileEntityColumnDetailComponent } from './tile-column-setting/tile-entity-column-detail.component';
import { TileRelationshipColumnDetailComponent } from './tile-column-setting/tile-relationship-column-detail.component';
import { TileMDLColumnDetailComponent } from './tile-column-setting/tile-mdl-column-detail.component';
import { TileFormulaColumnDetailComponent } from './tile-column-setting/tile-formula-column-detail.component';
import { TileColumnGroupComponent } from './tile-column-setting/tile-column-group.component';
import { TileChooseVisualizationComponent } from './tile-choose-visualization/tile-choose-visualization.component';
import { TileFilterComponent } from './tile-filter/tile-filter.component';
import { TileChartSettingComponent } from './tile-chart-setting/tile-chart-setting.component';
import { TileConditionalFormattingComponent } from './tile-conditional-formatting/tile-conditional-formatting.component';
import { DataVisualizationsComponent } from './data-visualizations/data-visualizations.component';
import { NoteTileChartSettingComponent } from './tile-chart-setting/note-tile-chart-setting/note-tile-chart-setting.component';
import { TileGridSettingComponent } from './tile-chart-setting/tile-grid-setting/tile-grid-setting.component';
import { TileContactColumnDetailComponent } from './tile-column-setting/tile-contact-column-detail.component';
import { TileFilterNearbyComponent } from './tile-filter/tile-filter-nearby/tile-filter-nearby.component';
@NgModule({
    imports: [
        // angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // 3rd party
        GridsterModule,
        // kendo
        ChartModule,
        DropDownsModule,
        PopupModule,
        InputsModule,
        // project
        WidgetsModule,
    ],
    declarations: [
        TileColumnSettingComponent,
        TileColumnComponent,
        TileEntryColumnDetailComponent,
        TileEntityColumnDetailComponent,
        TileContactColumnDetailComponent,
        TileRelationshipColumnDetailComponent,
        TileMDLColumnDetailComponent,
        TileFormulaColumnDetailComponent,
        TileColumnGroupComponent,
        TileChooseVisualizationComponent,
        TileFilterComponent,
        TileChartSettingComponent,
        NoteTileChartSettingComponent,
        TileConditionalFormattingComponent,
        DataVisualizationsComponent,
        TileGridSettingComponent,
        TileFilterNearbyComponent,
    ],
    providers: [
    ],
    exports: [
        TileColumnSettingComponent,
        TileChooseVisualizationComponent,
        TileFilterComponent,
        TileFilterNearbyComponent,
        TileChartSettingComponent,
        NoteTileChartSettingComponent,
        TileGridSettingComponent,
        DataVisualizationsComponent
    ]
})
export class TileSettingModule { }
